export enum ModalStatusEnum {
  form = 'form',
  sending = 'sending',
  success = 'success',
  error = 'error',
}
